import React, { useState } from 'react';
import { Button, Col, Row, Form } from "react-bootstrap";
import CustomSweetAlert from 'components/Shared/CustomSweetAlert';

const StepTen = ({ handleNext, storedData, handleBack }) => {
    const apiURL = process.env.REACT_APP_JOB_URL;
    const [alert, setAlert] = useState(null);
    const [formData, setFormData] = useState({
        checkRules: false
    });
    const [errors, setErrors] = useState({});


    const validateForm = (formData) => {
        const errors = {
            checkRules: formData?.checkRules === false ? 'Understand the rules is required' : undefined,
        };
        return errors;
    }

    const handleSubmit = async () => {
        try {
            const errors = validateForm(formData);
            if (!Object.values(errors).some(Boolean)) {
                setErrors([]);
                setAlert(CustomSweetAlert({ type: "loading" }));
                const url = `/HSInduction/SubmitDeclaration?inductionId=${storedData?.inductionId}&employeeId=${storedData?.employeeId}&pin=${storedData?.pin}`;
                const method = `post`;
                const response = await fetch(apiURL + url, {
                    method,
                    headers: [
                        ["Content-Type", "application/json"],
                        ["Content-Type", "text/plain"]
                    ],
                });
                if (response.status === 200) {
                    handleNext(true);
                } else {
                    showErrorAlert(`Please fill out all required fields`);
                }
            } else {
                setErrors(errors);
                window.scrollTo(0, 0);
            }

        } catch (e) {
            showErrorAlert("Failed to submit data");
        }
    }

    const handleCheck = (e) => {
        setFormData({
            ...formData,
            checkRules: !formData?.checkRules
        })
    }

    const hideAlert = () => setAlert(null);

    const showErrorAlert = (message) => setAlert(CustomSweetAlert({
        type: "error", title: "Error", message: message,
        onConfirm: () => {
            hideAlert();
        }, showCancel: false
    }));

    return (<>
        <Row>
            {alert}
            <Col sm={12} >
                <h2>8. Declaration</h2>
                <span style={{ marginTop: '-15px' }}></span>
            </Col>
            <Col sm={12}>
                <h5>1. I declare that I have carefully considered the answers that I have given to the above questions and that to the best of my knowledge and belief they are true and complete. 2. I understand that if the medical information I have provided is subsequently shown to be untrue or misleading, FP McCann may terminate my employment.</h5>
            </Col>
            <Col sm={12}>
                <h5>2. I understand that if the medical information I have provided is subsequently shown to be untrue or misleading, FP McCann may terminate my employment.</h5>
            </Col>
            <Col sm={12}>
                <h5>3. I understand that I may be required to attend a medical consultation and / or undergo a physical examination.</h5>
            </Col>
            <Col sm={12}>
                <h5>4. I understand that although this form will be treated in confidence, further medical information may be requested from my doctor if considered necessary. (Subject to obtaining further consent under the Access to Medical Records Act.)</h5>
            </Col>
            <Col sm={12} className="my-0">
                <label
                    className="vacancyLabel"
                    disabled={true}
                >
                    <h2 className='m-0 p-2 mt-1 mb-0'>Data Protection Act:</h2>
                    <h5 className='m-0 p-2 mt-0 mb-1'>Under the Data Protection Act, we are required to provide to you the data we hold on you, with information of how we manage this information on our digital and manual files. Should you have any queries please contact the HR Manager at FP McCann.</h5>
                </label>
            </Col>
            <Col sm={12}>
                <h5>5. I give FP McCann my consent to (a) hold relevant medical information (b) digitally record my personal and medical information; (c) contact me to arrange appointments and manage my case; including linking my medical history to sickness absence data; (d) contact my GP for a report if deemed necessary and (e) use my medical information to prepare an assessment of my fitness for work for my new employer.</h5>
            </Col>
            <Col sm={12}>
                <h5>6. I understand that FP McCann will retain my information securely and give me access to my medical information, should I request it in writing.</h5>
            </Col>
            <Col sm={12} md={12}>
                <Form.Group className='d-flex'>
                    <Form.Check.Label style={{ textAlign: 'left' }}>
                        <Form.Check.Input
                            type="checkbox"
                            checked={formData?.checkRules === true}
                            onChange={handleCheck}
                        ></Form.Check.Input>
                        <span className="form-check-sign" style={{ paddingRight: "10px" }}></span>
                        <><span>I confirm I have read and understand the above terms.</span><span className="star">*</span>
                        </>
                    </Form.Check.Label>
                </Form.Group>
                {errors.checkRules && <Form.Text className="text-danger d-flex"> <span className="star">*</span> {errors.checkRules} </Form.Text>}
            </Col>
        </Row>
        <Row>
            <Col sm={12} className="d-flex justify-content-end mt-3">
                <Button className="btn-lg btn-shadow btn-step" variamt="danger" onClick={handleBack} >Back</Button>
                <Button onClick={handleSubmit} variant="success" className="btn-lg btn-shadow">Submit</Button>
            </Col>
        </Row>
    </>
    );
};

export default StepTen;